import { z } from 'zod';
import { OrgFunctionSchema, OrgFunctionKindSchema } from '../../entities/org-function/org-function.schema';
import { optionalEmailSchema } from '../../shared/email.schema';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { ErrorCode } from '../../shared/error-codes';
/**
 * Add OrgFunction Request Schema
 * POST /api/v2/orgFunction
 *
 * Only `name` and `kind` are required. `lead` (Funktionsleiter), `department`,
 * `email`, and `description` are optional on BOTH kinds.
 */ export const AddOrgFunctionRequestSchema = z.object({
    name: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    kind: OrgFunctionKindSchema,
    email: optionalEmailSchema(),
    description: z.string().optional(),
    lead: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    department: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    // User IDs that get this OrgFunction as a secondary function. Membership is
    // never stored on the OrgFunction — the server writes the created id into
    // each listed user's `secondaryRoles` (the authoritative user-side store).
    // Validated as 24-hex ObjectIds at the wire boundary so a malformed id is a
    // 400, not a Mongoose CastError that surfaces as a 500.
    members: z.array(ObjectIdSchema).optional()
});
/**
 * Add OrgFunction Response Schema
 * POST /api/v2/orgFunction
 */ export const AddOrgFunctionResponseSchema = z.object({
    data: OrgFunctionSchema
});

//# sourceMappingURL=add-org-function.schema.js.map